import cn from "classnames";
import { useNavigate } from "react-router-dom";
import { Button, useMediaQuery } from "@rshbintech.dboul/core-ui";
import { useAppTranslation } from "../../../../hooks";
import { NotificationsFooterProps } from "./types";
import styles from "./styles.scss";

export const NotificationsFooter = ({
  className,
  onCloseNotificationsPopup,
}: NotificationsFooterProps) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("mobile");
  const { translate } = useAppTranslation("NOTIFICATION");

  const handleRedirectToNotifications = () => {
    onCloseNotificationsPopup();
    navigate("/notifications");
  };

  return (
    <footer className={cn(styles.footer, className)}>
      <Button
        onClick={handleRedirectToNotifications}
        htmlType="button"
        className={isMobile ? styles["button-mobile"] : styles.button}
        type={isMobile ? "primary" : "link"}
        data-rptracker-event="click"
        data-rptracker-category="notifications"
        data-rptracker-action="notificationsAllNotificationsClick"
      >
        {translate("REDIRECT_BUTTON_TEXT")}
      </Button>
    </footer>
  );
};
